export default "__VITE_ASSET__DlllmYrf__"